(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(scope) {
    (scope || document).querySelectorAll('[data-film-video]').forEach(video => {
      if (video.dataset.filmReady) return;
      video.dataset.filmReady = 'true';
      const hero = video.closest('.boo-hero');
      const toggle = hero && hero.querySelector('[data-film-toggle]');
      let wanted = !reduced.matches;
      video.muted = true; video.loop = true;
      const label = () => { if (!toggle) return; const on = !video.paused; toggle.textContent = on ? toggle.dataset.pause : toggle.dataset.play; toggle.setAttribute('aria-pressed', String(on)); };
      const play = () => { const p = video.play(); if (p && p.catch) p.catch(label); };
      video.addEventListener('play', label); video.addEventListener('pause', label);
      if (toggle) toggle.addEventListener('click', () => { if (video.paused) { wanted = true; play(); } else { wanted = false; video.pause(); } });
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else if (wanted) play(); });
      if (reduced.addEventListener) reduced.addEventListener('change', () => { if (reduced.matches) { wanted = false; video.pause(); } });
      if (wanted) play(); else { video.pause(); label(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
